<template>
  <pagefra>
    <div class="message">
      <panel>
        <div class="toolbar">
          <el-form
            class="toolbar-form"
            :inline="true"
            v-model="form"
            label-width
          >
            <el-form-item :label="$l('所属区域')">
              <areaCascader
                ref="ac"
                :multiple="true"
                :checkStrictly="true"
              ></areaCascader>
            </el-form-item>
            <el-form-item :label="$l('地盘名称')">
              <el-input
                v-model="form.domainName"
                :placeholder="$l('地盘名称')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('工号')">
              <el-input
                v-model="form.jobNum"
                :placeholder="$l('工号')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('业主')">
              <el-input
                v-model="form.ownerName"
                :placeholder="$l('业主')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('手机')">
              <el-input
                v-model="form.telNum"
                :placeholder="$l('手机')"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item :label="$l('发送时间')" placeholder="发送时间">
              <el-date-picker
                v-model="form.sendTime"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>-->
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
          >
            <el-table-column
              :label="$l('序号')"
              type="index"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('城市')"
              prop="city"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('地盘名称')"
              prop="domainName"
              align="center"
              width="120"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('大楼名称')"
              prop="buildingName"
              align="center"
              width="120"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('梯号')"
              prop="elevatorNum"
              align="center"
              width="120"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('工号')"
              prop="jobNum"
              align="center"
              width="150"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('业主')"
              prop="ownerName"
              align="center"
              width="150"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('手机')"
              prop="telNum"
              align="center"
              width="150"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('发送时间')"
              prop="sendTime"
              align="center"
              width="150"
              sortable
            ></el-table-column>
            <!-- <el-table-column label="接收时间" prop="receiveTime" align="center" width="150" sortable></el-table-column> -->
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>

      <el-dialog
        :title="$l('短信模板')"
        :visible.sync="dialogVisible"
        class="dialog-msg"
      >
        <p><em>张三</em>业主，您好！</p>
        <p>
          <em>金域蓝湾，听涛阁，2＃梯，</em>
          在
          <em>15:00:00</em>
          按计划保养，可能影响您的出行，敬请了解。电梯定期保养是国家特种设备管理规定的一项强制规定，对此给您带来的不便我们深表歉意。若有紧急情况请联系物业020-12345678。退订回复T。谢谢！
        </p>
      </el-dialog>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import breadcrumb from "@/components/breadcrumb.vue";
import areaCascader from "@/components/areaCascader.vue";
import global from "@/mixins/global.js";
export default {
  name: "maintainMsg",
  mixins: [global],
  components: {
    panel,
    breadcrumb,
    areaCascader,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        domainName: "",
        jobNum: "",
        ownerName: "",
        telNum: "",
        stopType: 0,
        dataPermissionList: [],
      },
      pickerOptions: {
        shortcuts: [
          {
            text: this.$l("最近一周"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$l("最近一个月"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$l("最近三个月"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      tableData: [],
      loading: false,
    };
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      this.form.dataPermissionList = this.$refs.ac.getSelectedList();
      this.tableData = [];
      this.loading = true;
      this.$http
        .post(this.$apiConfig.search_elevator_stop_sms_url, this.form)
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    showMsg() {
      this.dialogVisible = true;
    },
  },
  mounted() {
    if (this.loaded) {
      this.initData();
    }
  },
};
</script>
<style lang="scss" scoped>
.message {
}
</style>
